<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="840px">
        <div class="row" v-loading="loading">
            <div class="col-md-6">
                <x-input label="RUC" v-model="form.company_number" :maxlength="11"></x-input>
            </div>
            <div class="col-md-6">
                <x-input label="Razón Social" v-model="form.company_name"></x-input>
            </div>
            <div class="col-md-6">
                <x-input label="Nombre comercial" v-model="form.company_trade_name"></x-input>
            </div>
            <!--            <div class="col-md-6">-->
            <!--                <x-input label="Certificado" v-model="form.certificate"></x-input>-->
            <!--            </div>-->
            <div class="col-lg-6 col-md-6">
                <!--                <x-input label="Certificado" v-model="form.certificate"></x-input>-->
                <!--&lt;!&ndash;                <img v-if="preview" :src="preview" alt="Vista previa" class="img-fluid img-thumbnail mb-2">&ndash;&gt;-->
                <!--                <input type="file" ref="inputFile" class="hidden" @change="onSelectImage" accept="image/png, image/jpeg, image/jpg">-->
                <!--                <span class="text-muted">Se recomienda resoluciones 700x300</span>-->
                <!--                <el-button @click="onOpenFileLogo">Cambiar logo del establecimiento</el-button>-->
            </div>
            <div class="col-md-6">
                <x-input label="Usuario SOAP" v-model="form.soap_username"></x-input>
            </div>
            <div class="col-md-6">
                <x-input label="Contraseña SOAP" v-model="form.soap_password"></x-input>
            </div>
            <div class="col-md-6">
                <x-input label="Url SOAP" v-model="form.soap_url"></x-input>
            </div>
            <div class="col-12">
                <div class="table-responsive" v-if="form.certificate">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Archivo</th>
                            <th>F.Emisión</th>
                            <th>F.Vencimiento</th>
                            <th class="text-right">Acciones</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{ form.certificate }}</td>
                            <td>{{ form.certificate_date_of_issue }}</td>
                            <td>{{ form.certificate_date_of_due }}</td>
                            <td class="text-right">
                                <button type="button" class="btn waves-effect waves-light btn-xs btn-danger"
                                        @click.prevent="clickCertificateDelete">Eliminar
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <el-button type="primary" icon="el-icon-plus" @click="clickCertificateAdd">Subir</el-button>
                </div>
            </div>
            <establishment-certificate :showDialog.sync="showDialogCertificate"
                                       :recordId="establishmentId"
                                       @success="successCertificate"></establishment-certificate>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>

</template>

<script>

import {deletable} from '../../../../mixins/deletable'
import XModal from "../../../../components/XModal.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import EstablishmentCertificate from './EstablishmentCertificate.vue';

export default {
    name: 'EstablishmentCompanyForm',
    components: {EstablishmentCertificate, XButtonCancel, XButtonSubmit, XInput, XModal},
    props: ['showDialog', 'establishmentId'],
    mixins: [deletable],
    data() {
        return {
            showDialogCertificate: false,
            title: '',
            resource: 'establishments',
            loading: false,
            errors: {},
            form: {},
        }
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {
            this.title = 'Configuración - Empresa';
            this.errors = {};
            this.form = {
                id: this.establishmentId,
                company_number: null,
                company_name: null,
                company_trade_name: null,
                certificate: null,
                certificate_date_of_issue: null,
                certificate_date_of_due: null,
                soap_username: null,
                soap_password: null,
                soap_url: null,
            }
        },
        async handleOpen() {
            this.initForm();
            await this.getData();
        },
        async getData() {
            await this.$http.get(`/${this.resource}/record/${this.establishmentId}`)
                .then(response => {
                    this.form = Object.assign({}, this.form, response.data.data);
                })
        },
        async onSubmit() {
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.clickClose();
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        clickCertificateAdd() {
            this.showDialogCertificate = true;
        },
        async clickCertificateDelete() {
            await this.destroy(`/${this.resource}/certificates/${this.establishmentId}`)
                .then(() => {
                    this.getData()
                })
        },
        async successCertificate() {
            await this.getData()
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
